import { Chart, ChartType, TooltipModel } from "chart.js";

const getOrCreateTooltip = (chart: Chart) => {
  let tooltipEl = chart?.canvas?.parentNode?.querySelector("div");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.style.background = "var(--color-neutral-darkness)";
    tooltipEl.style.color = "white";
    tooltipEl.style.opacity = "1";
    tooltipEl.style.pointerEvents = "none";
    tooltipEl.style.position = "absolute";
    tooltipEl.style.transform = "translate(-50%, 0)";
    tooltipEl.style.transition = "all .1s ease";
    tooltipEl.style.borderRadius = "12px";
    // the look of the period menu: dark, its border and shadow
    tooltipEl.style.boxShadow = "0 12px 32px rgba(0, 0, 0, 0.45)";
    tooltipEl.style.whiteSpace = "nowrap";

    const divRoot = document.createElement("div");
    divRoot.style.padding = "8px 12px";
    divRoot.style.borderRadius = "12px";
    divRoot.style.border = "1px solid var(--color-neutral-base)";

    divRoot.id = "root";

    tooltipEl.appendChild(divRoot);
    chart.canvas.parentNode?.appendChild(tooltipEl);
  }

  return tooltipEl;
};

interface Context {
  chart: Chart;
  tooltip: TooltipModel<ChartType>;
}

export const externalTooltipHandler = (context: Context) => {
  // Tooltip Element
  const { chart, tooltip } = context;

  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltipEl && tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(b => b.lines);

    const bodyDiv = document.createElement("div");

    const titleLine = (titleLines as []).shift();
    const bodyLine = (bodyLines as []).shift();

    // "Dia 09/10 – 34": a dash between the day and its number
    const separator = document.createElement("span");
    separator.style.margin = "0 8px";
    separator.style.color = "var(--color-neutral-150)";
    separator.appendChild(document.createTextNode("–"));

    const lineWrapper = document.createElement("span");
    lineWrapper.style.fontWeight = "700";
    lineWrapper.appendChild(document.createTextNode(`${bodyLine}`));

    bodyDiv.appendChild(document.createTextNode(`${titleLine}`));
    bodyDiv.appendChild(separator);
    bodyDiv.appendChild(lineWrapper);

    const divRoot = tooltipEl.querySelector("#root");

    if (divRoot) {
      // Remove old children
      while (divRoot.firstChild) {
        divRoot.firstChild.remove();
      }

      // Add new children
      divRoot.appendChild(bodyDiv);
    }
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = "1";
  tooltipEl.style.left = positionX + tooltip.caretX + "px";
  tooltipEl.style.top = positionY + tooltip.caretY + "px";
  // the period menu's text: 14px Inter
  tooltipEl.style.fontSize = "14px";
  tooltipEl.style.lineHeight = "20px";
  tooltipEl.style.fontFamily = "'Inter', sans-serif";
  tooltipEl.style.padding = "0";
};
